import { KlaviyoForm } from '@theme/klaviyo-form';

class KlaviyoBackInStockForm extends KlaviyoForm {
  get #emailInput() {
    return this.querySelector('input[type="email"]');
  }

  get #variantIdInput() {
    return this.closest('form')?.querySelector('input[name="id"]')
      ?? this.querySelector('input[name="id"]');
  }

  async onFormSubmit(event){
    const email = this.#emailInput?.value?.trim();
    const variantId = this.#variantIdInput?.value;

    if (!email) {
      this.renderMessage('error', Theme.strings.klaviyo.errors.email_missing);
      return;
    }

    if (!variantId) {
      this.renderMessage('error', Theme.strings.klaviyo.errors.generic);
      return;
    }

    try {
      const response = await this.#createBackInStockSubscription({ email, variantId });

      if (!response.ok) {
        const data = await response.json();

        console.error('Klaviyo API Create Client Back In Stock Subscription error:', data);

        this.renderMessage('error',
          data?.errors?.[0]?.detail ?? Theme.strings.klaviyo.errors.generic
        );

        return;
      }

      this.renderMessage('success', Theme.strings.klaviyo.success.generic);
    } catch (error) {
      console.error('Klaviyo API Create Client Back In Stock Subscription fetch failed:', error);
    }
  };

  #createBackInStockSubscription({ email, variantId }) {
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.publicApiKey}`;

    const body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: [
            this.channel
          ],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };

    return fetch(url, {
      method: 'POST',
      headers: {
        revision: '2026-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(body)
    });
  }
}

if (!customElements.get('klaviyo-back-in-stock-form')) {
  customElements.define('klaviyo-back-in-stock-form', KlaviyoBackInStockForm);
}
